import { chunk } from '@belong/common';
import { Carousel } from '@belong/ui';
import { PrismicDocument } from '@prismicio/types';
import clsx from 'clsx';
import { BlogCard } from 'src/features/blog/components/card/card';
import styles from './blog-post-carousel.module.css';
import { BlogPostCarouselSlide } from './components/blog-post-carousel-slide/blog-post-carousel-slide';

type Props = {
  blogPostList: PrismicDocument[];
};

export function BlogPostCarousel({ blogPostList }: Props) {
  const mobileBlogPostSlides = chunk(blogPostList, 1);
  const tabletBlogPostSlides = chunk(blogPostList, 2);
  const desktopBlogPostSlides = chunk(blogPostList, 3);

  if (blogPostList.length === 1) {
    return (
      <div
        className={clsx(
          'gap-2xs flex flex-col items-stretch md:items-start',
          styles.singleBlogPostContainer,
        )}
      >
        <BlogCard post={blogPostList[0]!} variant="carousel" />
      </div>
    );
  }

  return (
    <div className="carousel-container">
      <div className="contents md:hidden">
        <Carousel arrowsOnDots>
          <BlogPostCarouselSlide blogPostSlides={mobileBlogPostSlides} />
        </Carousel>
      </div>
      {blogPostList.length <= 3 ? (
        <div className="md:gap-lg hidden md:grid md:grid-cols-3">
          {blogPostList.map((blogPost) => (
            <BlogCard key={blogPost.id} post={blogPost} variant="carousel" />
          ))}
        </div>
      ) : (
        <>
          <div className="hidden md:contents xl:hidden">
            <Carousel arrowsOnDots>
              <BlogPostCarouselSlide blogPostSlides={tabletBlogPostSlides} />
            </Carousel>
          </div>
          <div className="hidden xl:contents">
            <Carousel>
              <BlogPostCarouselSlide blogPostSlides={desktopBlogPostSlides} />
            </Carousel>
          </div>
        </>
      )}
    </div>
  );
}
